import type { OrganizationContextCapabilitiesResponse } from "@fp/admin-api-client";
import {
  getGetOrganizationContextCapabilitiesQueryKey,
  getOrganizationContextCapabilities,
} from "@fp/admin-api-client/organization-context/organization-context.client";
import type { QueryClient } from "@tanstack/react-query";
import { redirect } from "@tanstack/react-router";

export const redirectUnlessCapability = async (
  queryClient: QueryClient,
  capability: keyof OrganizationContextCapabilitiesResponse,
) => {
  const capabilities = await queryClient.ensureQueryData({
    queryKey: getGetOrganizationContextCapabilitiesQueryKey(),
    queryFn: () => getOrganizationContextCapabilities(),
  });

  if (!capabilities.data[capability]) {
    throw redirect({ to: "/dashboard" });
  }
};
